/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["section[_ngcontent-%COMP%]{margin-bottom:25px;background-color:#f7f7f7}section[_ngcontent-%COMP%]   .add-category[_ngcontent-%COMP%]{background-color:transparent;height:25vh;display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center}section[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{fill:#85cddb;height:14vh;display:block;padding-bottom:1.5vh}"];
export { styles as styles };
